import { sendHttp } from '../assets/js/request'

const commonApi = {
  // 获取登录用户信息
  getUserProfile: () => {
    return sendHttp('get', '/system/user/profile')
  },
  // 保存登录用户信息
  saveUserInfo: params => {
    return sendHttp('post', '/system/user/update', params)
  },
  // 获取用户所属权限下的菜单
  getUserMenus: () => {
    return sendHttp('get', '/system/menu/indexMenu')
  },
  // 查询系统字典数据
  getSystemDic (params) {
    return sendHttp('get', '/system/dict/data/list', params)
  },
  // 查询部门血糖配置
  getDeptGlucoseConfig (params) {
    return sendHttp('get', '/business/glucoseconfig/getByDeptId', params)
  },
  // 获取部门报警设置
  getDeptAlertConfig: params => {
    return sendHttp('get', '/cgm/config/getDeptConfig', params)
  },
  // 获取部门树
  getDeptTreeData (params) {
    return sendHttp('get', '/system/dept/treeData', params)
  },
  // 获取测量时段数据
  getPeriodDic (params) {
    return sendHttp('get', '/system/sysGlucosePeriod/list', params)
  }
}

export { commonApi }



// WEBPACK FOOTER //
// ./src/apis/commonApi.js